








import moment from 'moment'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import { ProxyDelayDateType } from '../../../logic/Proxy/ProxyDelayTypes'

@Component({
  data() {
    return {
      moment,
    }
  }
})
export default class SampleDelayDateType extends Vue {
  @Prop() delay!: ProxyDelayDateType
}
